import {Link, NavLink, Outlet, useLocation, useNavigate, useRouteError} from 'react-router-dom';
import {capabilityBand} from './data';

export function ScoreBar({score}: {score: number}) {
  return <span className="score-bar" aria-label={`${score.toFixed(1)} out of 10`}><i style={{width: `${Math.max(0, Math.min(100, score * 10))}%`}} /></span>;
}

export function ScoreValue({score}: {score: number}) {
  return <span className={score === 0 ? 'score-value zero' : 'score-value'}>{score.toFixed(1)}<small>{capabilityBand(score)}</small></span>;
}

const navItems = [
  ['/', 'Overview'],
  ['/capabilities', 'Capabilities'],
  ['/matrix', 'Pairing Matrix'],
  ['/pairs', 'Pairing Index'],
  ['/factions', 'Faction Index'],
  ['/mechanics', 'Special Mechanics'],
  ['/methodology', 'Methodology'],
];

export function AppLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search).get('q') ?? '';

  function search(value: string) {
    const section = location.pathname.startsWith('/pairs') || location.pathname === '/matrix'
      ? '/pairs'
      : location.pathname.startsWith('/capabilities') ? '/capabilities'
      : location.pathname.startsWith('/mechanics') ? '/mechanics' : '/factions';
    navigate(value ? `${section}?q=${encodeURIComponent(value)}` : section);
  }

  return <div className="app-shell">
    <aside className="sidebar">
      <Link className="brand" to="/"><span className="brand-mark" aria-hidden="true">SU</span><span>Smash Up<small>Field Reference</small></span></Link>
      <nav aria-label="Primary navigation">
        {navItems.map(([to, label]) => <NavLink key={to} to={to} end={to === '/'}>{label}</NavLink>)}
      </nav>
      <p className="scope">Original printed cards and rules. The 2025 errata and rebalances are excluded.</p>
    </aside>
    <div className="main-column">
      <header className="topbar">
        <label className="search"><span className="sr-only">Search reference</span><input value={query} onChange={event => search(event.target.value)} placeholder="Search factions, capabilities, or pairings…" /></label>
      </header>
      <main><Outlet /></main>
      <footer>Original-print analytical reference · Parent capability summaries are presentation-only.</footer>
    </div>
  </div>;
}

export function PageLoading() {
  return <section className="loading" aria-live="polite"><span />Loading reference data…</section>;
}

export function RouteError() {
  const error = useRouteError();
  const message = error instanceof Response && error.status === 404 ? 'That reference page does not exist.' : 'This reference page could not be loaded.';
  return <section className="error-page"><p className="eyebrow">Navigation error</p><h1>{message}</h1><p>The generated data may be missing or the URL may be invalid.</p><Link className="button" to="/">Return to overview</Link></section>;
}

export function NotFound() {
  return <section className="error-page"><p className="eyebrow">404</p><h1>Page not found</h1><p>No route matches this address.</p><Link className="button" to="/">Return to overview</Link></section>;
}
